module.exports = __webpack_public_path__ + "static/banner1-89216793ece1ac637db906efafdc61bd.png";